import script from "./ItemDepots.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDepots.vue?vue&type=script&setup=true&lang=js"

import "./ItemDepots.vue?vue&type=style&index=0&id=60268daf&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60268daf"]])

export default __exports__